import { z } from "zod";

/** Which of the caller's approvals to list: those still waiting on them, or those they decided. */
export const MY_INCOMING_INVOICE_APPROVAL_FILTERS = ["pending", "decided"] as const;

export const getMyIncomingInvoiceApprovalsQuerySchema = z.object({
	state: z.enum(MY_INCOMING_INVOICE_APPROVAL_FILTERS).default("pending"),
});

export type GetMyIncomingInvoiceApprovalsQuerySchema = z.infer<
	typeof getMyIncomingInvoiceApprovalsQuerySchema
>;
